export const VERSION = '4.3.7-gogreen';
export const GIT_HASH = 'f20017639e7bfeaaed4088ca1fce69a022c8840e';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
